"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "ButtonVariant", {
  enumerable: true,
  get: function get() {
    return _types.ButtonVariant;
  }
});
_Object$defineProperty(exports, "ButtonVariantType", {
  enumerable: true,
  get: function get() {
    return _types.ButtonVariantType;
  }
});
_Object$defineProperty(exports, "buttonVariants", {
  enumerable: true,
  get: function get() {
    return _types.buttonVariants;
  }
});
exports.default = void 0;
var _Button = _interopRequireDefault(require("./Button"));
var _types = require("./types");
function cov_2fgt2cnmfp() {
  var path = "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/index.js";
  var hash = "d63245df9b3d70d4a3a9bd19a44043a674c11f5b";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src3108803385/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/ui/Button/lib/index.js",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "d63245df9b3d70d4a3a9bd19a44043a674c11f5b"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2fgt2cnmfp = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2fgt2cnmfp();
var _default = exports.default = _Button.default;